import { render, staticRenderFns } from "./WForm.vue?vue&type=template&id=695989c9&"
import script from "./WForm.vue?vue&type=script&lang=js&"
export * from "./WForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports